import { LayoutComponent } from "../../../components";
import { Outlet } from "react-router-dom";

export function UseCasesLayout() {
  return (
    <LayoutComponent selectedMenuItem={"catalog"}>
      <Outlet />
    </LayoutComponent>
  );
}
